import React from 'react';

import Icon from 'dpl/common/components/Icon';
import { SOCIAL_SHARE_TYPES } from 'dpl/shared/constants/social';
import { getSocialShareLink } from 'dpl/util/social';

import { ARTICLE_CONTENT_COL_CLASSES } from '../utils/constants';

export default function ShareBar() {
  return (
    <div className="PrismicShareBar container">
      <div className="row">
        <div className={ARTICLE_CONTENT_COL_CLASSES}>
          <p className="mb2 ttu f2 fw-medium">Share this article</p>
          <ul className="flex align-items-center nh2">
            {Object.values(SOCIAL_SHARE_TYPES).map(type => (
              <li className="mh2" key={type}>
                <a
                  className="pv1 ph1 ba bw1 b--black br-100 flex align-items-center"
                  href={getSocialShareLink(type)}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <Icon name={type} />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
